export default __webpack_public_path__ + "static/media/RiddhiDutta.0635570f.jpeg";